/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const list_users = /* GraphQL */ `
  query List_users {
    list_users
  }
`;
export const list_organizations = /* GraphQL */ `
  query List_organizations {
    list_organizations
  }
`;
export const get_organization_api_usage = /* GraphQL */ `
  query Get_organization_api_usage($input: getOrganizationApiUsageInput) {
    get_organization_api_usage(input: $input)
  }
`;
export const get_bms_global_settings = /* GraphQL */ `
  query Get_bms_global_settings {
    get_bms_global_settings
  }
`;
export const list_categories = /* GraphQL */ `
  query List_categories($input: categoryInputs) {
    list_categories(input: $input)
  }
`;
export const list_template = /* GraphQL */ `
  query List_template($input: templateInputs) {
    list_template(input: $input)
  }
`;
export const list_medication_masters = /* GraphQL */ `
  query List_medication_masters($input: medicationInputs) {
    list_medication_masters(input: $input)
  }
`;
export const list_medication_class = /* GraphQL */ `
  query List_medication_class {
    list_medication_class
  }
`;
export const list_announcement = /* GraphQL */ `
  query List_announcement($input: announcementInputs) {
    list_announcement(input: $input)
  }
`;
export const list_announcement_views = /* GraphQL */ `
  query List_announcement_views($input: announcementInputs) {
    list_announcement_views(input: $input)
  }
`;
export const list_master_checklists = /* GraphQL */ `
  query List_master_checklists($input: MasterChecklistInput) {
    list_master_checklists(input: $input)
  }
`;
export const calculate_license_pricing = /* GraphQL */ `
  query Calculate_license_pricing($input: calculateLicenseInput) {
    calculate_license_pricing(input: $input)
  }
`;
export const get_license_usage_summary = /* GraphQL */ `
  query Get_license_usage_summary($input: getLicenseUsageSummaryInput) {
    get_license_usage_summary(input: $input)
  }
`;
export const list_audit_logs = /* GraphQL */ `
  query List_audit_logs($input: listAuditLogsInput) {
    list_audit_logs(input: $input)
  }
`;
export const get_section_settings = /* GraphQL */ `
  query Get_section_settings($input: getSectionSettingsInput) {
    get_section_settings(input: $input)
  }
`;
export const list_testimonials = /* GraphQL */ `
  query List_testimonials($input: testimonialInputs) {
    list_testimonials(input: $input)
  }
`;
export const list_blogs = /* GraphQL */ `
  query List_blogs($input: blogInputs) {
    list_blogs(input: $input)
  }
`;
export const list_user_guide_main_modules = /* GraphQL */ `
  query List_user_guide_main_modules($input: userGuideTopicInputs) {
    list_user_guide_main_modules(input: $input)
  }
`;
export const list_user_guide_sub_modules = /* GraphQL */ `
  query List_user_guide_sub_modules($input: userGuideTopicInputs) {
    list_user_guide_sub_modules(input: $input)
  }
`;
export const list_knowledge_base_files = /* GraphQL */ `
  query List_knowledge_base_files($input: kbFileInputs) {
    list_knowledge_base_files(input: $input)
  }
`;
export const list_master_medication_categories = /* GraphQL */ `
  query List_master_medication_categories(
    $input: medicationCategoryMastersInputs
  ) {
    list_master_medication_categories(input: $input)
  }
`;
export const list_lab_masters = /* GraphQL */ `
  query List_lab_masters($input: labMastersInputs) {
    list_lab_masters(input: $input)
  }
`;
export const get_ticket = /* GraphQL */ `
  query Get_ticket($input: ticketInputs) {
    get_ticket(input: $input)
  }
`;
export const list_tickets = /* GraphQL */ `
  query List_tickets($input: ticketInputs) {
    list_tickets(input: $input)
  }
`;
export const list_support_modules_masters = /* GraphQL */ `
  query List_support_modules_masters {
    list_support_modules_masters
  }
`;
export const list_support_agents = /* GraphQL */ `
  query List_support_agents {
    list_support_agents
  }
`;
export const get_auto_close_days = /* GraphQL */ `
  query Get_auto_close_days {
    get_auto_close_days
  }
`;
export const list_knowledge_reviews = /* GraphQL */ `
  query List_knowledge_reviews {
    list_knowledge_reviews
  }
`;
